import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-20 px-4 bg-white relative overflow-hidden" data-id="element-215">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-216">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-217">
          <span className="inline-block bg-[#C4A7E7] text-[#111111] font-black tracking-widest px-6 py-2 rounded-full text-sm md:text-base mb-6 shadow-md" data-id="element-218">
            LA SOLUCIÓN
          </span>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-[#C4A7E7] mb-8 tracking-tight" data-id="element-219">
            MEGA KIT ALFABETIZACIÓN EN AUTISMO™
          </h2>

          <p className="text-xl md:text-2xl text-[#111111] mb-10 leading-relaxed max-w-3xl mx-auto font-medium" data-id="element-220">
            El sistema completo de alfabetización para niños con autismo que
            funciona en casa y en el aula al mismo tiempo.
          </p>

          <p className="text-lg md:text-xl text-gray-700 mb-12 max-w-2xl mx-auto" data-id="element-221">
            Sin improvisar. Sin buscar material. Sin cortocircuitos entre lo que
            se hace en un lugar y lo que se hace en el otro. Todo el material ya
            está escrito, organizado y listo.
          </p>

          <div className="bg-gray-50 rounded-3xl p-6 md:p-10 shadow-lg border border-gray-100 max-w-2xl mx-auto flex flex-col md:flex-row items-center gap-6 md:gap-8" data-id="element-222">
            <div className="flex-shrink-0" data-id="element-223">
              <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&h=600&fit=crop&crop=face" loading="lazy" decoding="async" alt="Creadora del MEGA KIT" className="w-56 h-56 md:w-72 md:h-72 rounded-2xl object-cover shadow-md" data-id="element-224" />
            </div>
            <div className="text-center md:text-left" data-id="element-225">
              <p className="text-lg md:text-xl font-black text-[#111111] mb-1" data-id="element-226">
                Creado por una profesional que trabaja con autismo todos los
                días
              </p>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed" data-id="element-227">
                Especialista en alfabetización y desarrollo del lenguaje en
                niños con TEA. Años de experiencia en aula y consultorio,
                trabajando codo a codo con familias y docentes para construir un
                sistema que realmente funcione.
              </p>
              <p className="text-sm text-[#C4A7E7] font-semibold mt-3 italic" data-id="element-228">
                "Diseñé este kit porque ningún material existente resolvía lo
                que yo veía todos los días en mis sesiones."
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}